import moment from 'moment';
import React, { Component } from 'react';

import './ReviewTable1.scss';
import { ICONS } from '../../common/constants'
import FontAwesomeIcon from '../Icon';
import { get } from 'lodash';
import classNames from 'classnames';

class ReviewTable1 extends Component {
    state = {
      accessor: '',
      direction: '',
    };
  
    render() {
      const { columns, data, simplifiedMobileWalkThrough } = this.props
      const { accessor, direction } = this.state;
      const sorted = data.slice().sort((a, b) => {
        if (get(a, accessor) > get(b, accessor)) {
          return -1;
        }
        if (get(b, accessor) > get(a, accessor)) {
            return 1;
        }
        return 0;
      });
  
      const results = direction === 'ascending' ? sorted.reverse() : sorted;
  
      return (
        <table className="reviewTable1">
          <thead className="reviewTable1__head">
            <tr className={
              classNames(
                "reviewTable1__row",
                {
                  "reviewTable1__row__fixed":true
                }
              )
            }>
              {columns.map((c, i) => (
                <th
                  key={i}
                  className={
                    classNames(
                      'reviewTable1__header',
                      {
                        'reviewTable1__header--center': c.center,
                        'reviewTable1__header--hide-xs': c.xsHide,
                        'reviewTable1__header--description':c.label === 'Description',
                       // 'reviewTable1__data--Ticket--Number':c.label === 'Ticket Number',
                        'reviewTable1__data--Ticket--Number':c.label === 'Ticket Number' || c.label === 'Room',
                        'reviewTable1__header--colored':simplifiedMobileWalkThrough === true,
                        'reviewTable1__header--description--width':simplifiedMobileWalkThrough === true
                      }
                    )
                  }
                >
                  {c.sortable ? (
                    <button
                      className="reviewTable1__sort"
                      onClick={() => this.setState({
                          accessor: c.accessor,
                          direction: direction === 'ascending'
                            ? 'descending'
                            : 'ascending',
                      })}
                    >
                    {c.label}
                    {c.accessor === accessor && (
                      <FontAwesomeIcon
                        glyph={direction === 'ascending' ? 'caret-up' : 'caret-down'}
                        weight="solid"
                      />
                    )}
                  </button>
                  ) : c.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="reviewTable1__body">
            {results.map((d, i) => (
              <tr
                key={i}
                className="reviewTable1__row"
              >
                {columns.map((c, x) => (
                  <td
                    key={x}
                    className={
                      classNames(
                        'reviewTable1__data',
                        {
                         'reviewTable1__data--center': c.center,
                         'reviewTable1__data--hide-xs': c.xsHide,
                         'reviewTable1__data--description':c.label === 'Description',
                         'reviewTable1__data--Ticket--Number':c.label === 'Ticket Number' || c.label === 'Room',
                         'reviewTable1__data--borderLess':simplifiedMobileWalkThrough === true,
                         'reviewTable1__data--description--width':simplifiedMobileWalkThrough === true
                        }
                      )
                    }
                  >
                    {c.cell
                      ? c.cell(d)
                      : get(d, c.accessor)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )
    }
  }
  export default ReviewTable1;